import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { monochrome } from '../../theme/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 400,
      color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
    },
    dialogContent: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      gridGap: '8px',
    },
    dialog: {
      '& .MuiDialog-paper': {
        width: '100%',
        maxWidth: '600px',
        [theme.breakpoints.down('xs')]: {
          maxWidth: '100%',
        },
      },
    },
    submitButton: {
      width: '100px',
    },
  })
);
